import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3463f18b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "col-form-label fw-bold mb-2" }
const _hoisted_3 = { class: "d-flex justify-content-end mb-3" }
const _hoisted_4 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_5 = { class: "d-lg-flex" }
const _hoisted_6 = { class: "mx-lg-4" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  colspan: "11",
  class: "text-center fw-bold"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  colspan: "11",
  class: "text-center fw-bold"
}
const _hoisted_12 = { class: "text-init w_200" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "w_100 text-nowrap" }
const _hoisted_15 = {
  key: 0,
  class: "w_110"
}
const _hoisted_16 = {
  key: 1,
  class: "w_110"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 2,
  class: "w_110"
}
const _hoisted_19 = {
  key: 3,
  class: "w_110"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 4,
  class: "w_110"
}
const _hoisted_22 = {
  key: 5,
  class: "w_110"
}
const _hoisted_23 = {
  key: 6,
  class: "w_110"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "w_200" }
const _hoisted_26 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_27 = { class: "mx-1" }
const _hoisted_28 = { class: "w_150" }
const _hoisted_29 = { class: "not-seperate-text" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-danger" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "d-lg-flex" }
const _hoisted_35 = { class: "mx-lg-4" }

import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Search from '@/views/community-admin/post-management/components/Search.vue'
import ModalDelete from '@/views/community-admin/post-management/components/ModalDelete.vue'
import ModalEdit from '@/views/community-admin/post-management/components/ModalEdit.vue'
import ModalCreate from '@/views/community-admin/post-management/components/ModalCreate.vue'
import { computed, ComputedRef, ref, watch, onMounted, reactive } from 'vue'
import { ReplayName, numberWithCommas, LIST_USER_NAME } from '@/constants/common'
// import CellSort from '@/components/cell-sort/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import Table from '@/components/table/index.vue'
import Loading from '@/components/loading/index.vue'

import { translate } from '@/languages/i18n'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { COMMUNITY_SITE_ADMIN_STORE, COMMUNITY_STORE } from '@/store/constants'
import { ACCOUNT_STORE, POST_STORE, USER_POST_STORE } from '@/store/constants'
import { GetPostType } from '@/store/modules/user-post-management/user-post.getters'
import dayjs from 'dayjs'
import ModalCreateSuccess from '@/views/community-admin/post-management/components/ModalCreateSuccess.vue'
import ModalEditSuccess from '@/views/community-admin/post-management/components/ModalEditSuccess.vue'
import InterestModal from '@/views/community-admin/post-management/components/InterestModal.vue'
import LikeModal from '@/views/community-admin/post-management/components/LikeModal.vue'
import PostModal from '@/views/community-admin/post-management/components/ModalPost.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'

import ModalUpdateStatusChat from '@/views/community-admin/post-management/components/ModalUpdateStatus.vue'
import ModalUpdatePrivateSuccess from '@/views/community-admin/groups/components/ModalUpdatePrivateSuccess.vue'
import ModalUpdatePublicSuccess from '@/views/community-admin/groups/components/ModalUpdatePublicSuccess.vue'
import DeleteCommentModal from '@/views/shared/communities/components/DeleteCommentModal.vue'
import DeleteCommentSuccessModal from '@/views/shared/communities/components/DeleteCommentSuccessModal.vue'
import UpdateCommentErrorModal from '@/views/shared/communities/components/UpdateCommentErrorModal.vue'
import { pick } from 'lodash'
import TotalRecords from '@/components/total-records/index.vue'
import { Modal } from 'bootstrap'
import { ARTICLE_MODAL_ID, COMMENT_USER_ALUMNI_MODAL_ID, COMMENT_USER_MODAL_ID } from '@/views/community-admin/community-site/constants'
import CommunitySitePostModal from '@/views/community-admin/community-site/components/modals/ArticleModal.vue'
import { CommentType } from '@/store/modules-community-admin/community-site'
import { changeModalElevation, isSaasTypePool } from '@/utils'
import { SetCurrentComment } from '@/store/modules/user-post/user-post.mutations'
import post from '@/store/modules/post'
import ModalConfirmStatusComment from '@/views/community-admin/post-management/components/ModalConfirmStatusComment.vue'
import ModalUpdateStatusCommentResult from '@/views/community-admin/post-management/components/ModalUpdateStatusCommentResult.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentData = ref({
  viewPost: {},
  viewEdit: {},
  viewDelete: {},
})
const router = useRouter()
const route = useRoute()
const store = useStore()
const count = ref<number>(0)
//2022/11/12 TienNV Fix for UAT#5121: OF10 (Ph2-R20221116)
const modalEdit = ref()
const modalDelete = ref()
const modalViewPost = ref()
const modalDeleteComment = ref()
const modalDeleteCommentSuccess = ref()
const modalDeleteCommentError = ref()
const commentIsDelete = ref(true)
const articleDetailModalController = ref()

const commentUserInfoModal = ref()
const commentAlumniInfoModal = ref()

const postDetail = computed(() => store.getters[USER_POST_STORE.GETTERS.GET_POST_DETAIL])
const listUserMention = computed(() => store.getters[POST_STORE.GETTERS.LIST_USER_MENTION_POST])
const listUser = computed(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])

const storeSaasType = computed(() => store.getters[COMMUNITY_STORE.GETTERS.GET_SAAS_TYPE])

const convertContentType = (content_type: number): string => {
  const contentTypeObj = {
    1: '記事',
    2: '募集',
    3: '求人',
    4: '自動投稿',
    // 5: translate('article'), // HoaVQ #14377
    5: '記事（自動投稿）', // HoaVQ #14377
  }

  return contentTypeObj[content_type]
}

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

const modalConfirmStatusComment = ref()
const modalUpdateStatusCommentResult = ref()
const resultUpdateStatusComment = reactive({
  success: true,
  commentPublished: true,
})
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('postManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('adminUserPost'),
    to: '',
    active: true,
  },
]

const checkSearchData = computed((): boolean => Object.keys(pick(route.query, 'title', 'content', 'user_name')).length > 0 && postData.value?.posts?.length === 0)

const getInterest = (id: string): void => {
  store.dispatch(POST_STORE.ACTIONS.GET_INTEREST, { id: id, params: { create_by_admin: true } })
}

const getLike = (id: string): void => {
  store.dispatch(POST_STORE.ACTIONS.GET_LIKES, { id: id, params: { create_by_admin: true } })
}

const getListUser = async () => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_USER_WITH_DELETED, route?.params?.id)
}

const getUserMention = async (postId) => {
  if (storeSaasType.value && !isSaasTypePool(storeSaasType.value)) {
    await store.dispatch(POST_STORE.ACTIONS.GET_USER_MENTION_POST, { post_id: postId, create_by_admin: true })
  }
}

const postItem = ref()
//2022/11/12 TienNV Fix for UAT#5121: OF10 (Ph2-R20221116)
const setCurrentData = async (postId: any, type: string): void => {
  await getUserMention(postId)
  const data = postData.value?.posts.filter((post) => post.id === postId)[0]
  postItem.value = data
  const getDetailPayload = {
    screen: 'operationalPost',
    community_id: route.params.id,
    postId,
    params: {
      target_content_id: route.query?.target_content_id,
    },
  }
  if (data.content_type === 5 && data.is_community_site_deleted) {
    getDetailPayload.params = {
      ...getDetailPayload.params,
      from_ct_10: true,
    }
  }
  await store.dispatch(USER_POST_STORE.ACTIONS.SET_POST_DETAIL, getDetailPayload)
  currentData.value[type] = postDetail.value.post
  //2022/11/14 TienNV Fix for UAT#5121: OF10 (Ph2-R20221116)
  currentData.value[type].create_by_admin = true

  if (type === 'viewEdit' && postDetail.value !== 'error') modalEdit.value.show()
  else if (type === 'viewDelete' && postDetail.value !== 'error') modalDelete.value.show()
  else if (type === 'viewPost' && postDetail.value !== 'error') modalViewPost.value.show()
  store.dispatch(USER_POST_STORE.ACTIONS.SET_SHOW_ALL_COMMENTS, false)
  count.value++
}

// Show modal detail when exists post_id
const setCurrentDataPostDetail = async (postId: any, type: string): void => {
  await getUserMention(postId)
  await store.dispatch(USER_POST_STORE.ACTIONS.SET_POST_DETAIL, {
    screen: 'operationalPost',
    community_id: route.params.id,
    postId,
    params: {
      target_content_id: route.query?.target_content_id,
    },
  })
  currentData.value[type] = postDetail.value.post
  if (currentData.value[type]) currentData.value[type].create_by_admin = true

  modalViewPost.value.show()
  store.dispatch(USER_POST_STORE.ACTIONS.SET_SHOW_ALL_COMMENTS, false)
}

const openCommunitySiteModal = async (postId: any, communitySiteArticleDeleted: boolean) => {
  await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.GET_ARTICLE_DETAIL, {
    screen: 'communitySite',
    community_id: route.params.id,
    postId: postId ?? 0,
    params: {
      target_content_id: route.query?.target_content_id,
      from_ct_10: communitySiteArticleDeleted ? true : null,
    },
  })
  const articleModal = new Modal(document.getElementById(ARTICLE_MODAL_ID) as HTMLElement)
  articleModal.show()
}

const showDeleteCommentModal = () => {
  modalDeleteComment.value.show()
}

const showDeleteCommunitySiteCommentModal = (comment: CommentType) => {
  const payload: SetCurrentComment = {
    post_id: comment.post_id,
    comment_id: comment.id,
  }
  store.dispatch(USER_POST_STORE.ACTIONS.SET_CURRENT_COMMENT, payload)
  setCommentData(comment.post_id, comment.id, comment.published)
  showDeleteCommentModal()
}

const showDeleteCommentSuccessModal = async (isDelete) => {
  const communitySiteModalIsShown = document.getElementById(ARTICLE_MODAL_ID).className?.includes('show')
  if (isDelete.success && communitySiteModalIsShown) {
    if (!articleDetailModalController.value?.reloadCommentList()) {
      const articleDetail = store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.ARTICLE_DETAIL]
      const data = postData.value?.posts.filter((post) => post.id === articleDetail.id)[0]
      const getDetailPayload = {
        screen: 'communitySite',
        community_id: route.params.id,
        postId: data.id ?? 0,
      }
      if (data.is_community_site_deleted) {
        getDetailPayload['params'] = { from_ct_10: true }
      }
      await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.GET_ARTICLE_DETAIL, getDetailPayload)
    }
    return
  }
  commentIsDelete.value = isDelete
  modalDeleteCommentSuccess.value.show()
}

const showUpdateCommentErrorModal = () => {
  // modalDeleteCommentError.value.show()
}
const showUpdateStatusCommentModal = () => {
  modalConfirmStatusComment.value.show()
}

const afterUpdateStatusComment = (resultObject) => {
  resultUpdateStatusComment.success = resultObject.resultUpdate
  resultUpdateStatusComment.commentPublished = resultObject.commentPublished
  modalConfirmStatusComment.value.hide()
  setTimeout(() => {
    modalUpdateStatusCommentResult.value.show()
  }, 400)
}

const postData = computed<ComputedRef<GetPostType>>(() => store.getters[USER_POST_STORE.GETTERS.GET_POST])

onMounted(() => {
  // 2022/09/12 CW-Phuong Fix for horizontal fixing#7: CT10
  router.push({ path: route.path, query: { ...route.query, created_at: 'desc' } })
  const modalInterest = document.querySelector('#interest')
  const modalPost = document.querySelector('#modalPost')
  const modalLike = document.querySelector('#like')

  modalInterest.addEventListener('hidden.bs.modal', function () {
    hiddenModal()
  })
  modalPost.addEventListener('hidden.bs.modal', function () {
    hiddenModal()
  })
  modalLike.addEventListener('hidden.bs.modal', function () {
    hiddenModal()
  })

  const elementDeleteCommentModal = document.getElementById('deleteComment')
  const elementDeleteCommentSuccessModal = document.getElementById('deleteCommentSuccess')
  const elementConfirmStatusComment = document.getElementById('modalConfirmStatusComment')
  const elementConfirmStatusCommentResult = document.getElementById('modalUpdateStatusCommentResult')
  elementDeleteCommentModal?.addEventListener('show.bs.modal', displayBackdropInFrontOfPost)
  elementDeleteCommentSuccessModal?.addEventListener('show.bs.modal', displayBackdropInFrontOfPost)
  elementDeleteCommentModal?.addEventListener('hidden.bs.modal', displayBackdropInBackOfPost)
  elementDeleteCommentSuccessModal?.addEventListener('hidden.bs.modal', displayBackdropInBackOfPost)
  elementConfirmStatusComment?.addEventListener('show.bs.modal', displayBackdropInFrontOfPost)
  elementConfirmStatusComment?.addEventListener('hidden.bs.modal', displayBackdropInBackOfPost)
  elementConfirmStatusCommentResult?.addEventListener('show.bs.modal', displayBackdropInFrontOfPost)
  elementConfirmStatusCommentResult?.addEventListener('hidden.bs.modal', displayBackdropInBackOfPost)

  //2022/11/12 TienNV Fix for UAT#5121: OF10 (Ph2-R20221116)
  modalEdit.value = new Modal(document.getElementById('modalEdit'))
  modalDelete.value = new Modal(document.getElementById('modalDelete'))
  modalViewPost.value = new Modal(document.getElementById('modalPost'))
  modalDeleteComment.value = new Modal(elementDeleteCommentModal)
  modalDeleteCommentSuccess.value = new Modal(elementDeleteCommentSuccessModal)
  modalDeleteCommentError.value = new Modal(document.getElementById('updateCommentError'))

  commentUserInfoModal.value = new Modal(overlayModal(COMMENT_USER_MODAL_ID))
  commentAlumniInfoModal.value = new Modal(overlayModal(COMMENT_USER_ALUMNI_MODAL_ID))
  modalConfirmStatusComment.value = new Modal(elementConfirmStatusComment)
  modalUpdateStatusCommentResult.value = new Modal(elementConfirmStatusCommentResult)

  document.getElementById(ARTICLE_MODAL_ID).addEventListener('hide.bs.modal', () => {
    const articleDetail = store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.ARTICLE_DETAIL]
    store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.GET_ARTICLE_DETAIL, {
      screen: 'CT10',
      community_id: route.params.id,
      postId: articleDetail.id,
      params: {
        destination: 'list',
      },
    })
    articleDetailModalController.value?.resetCommentInput()
    store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.CLEAR_SELECTED_DATA)
  })
})

const overlayModal: HTMLElement = (idModal: string) => {
  const element = document.getElementById(idModal)
  element.addEventListener('hide.bs.modal', () => {
    changeModalElevation(ARTICLE_MODAL_ID, 'higher')
  })
  return element
}

const hiddenModal = () => {
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  while (modalBackdrop.length > 0) {
    modalBackdrop[0].parentNode.removeChild(modalBackdrop[0])
  }
}

// モーダルを重ねて表示する際に、backdropを最前面のモーダルの後ろに配置する
const displayBackdropInFrontOfPost = () => {
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  if (modalBackdrop.length > 0) {
    modalBackdrop[0].style.zIndex = 1599
  }
}

// モーダルを閉じる際に、前面に持ってきたbackdropを元の位置に戻す
const displayBackdropInBackOfPost = () => {
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  for (const backdrop of modalBackdrop) {
    backdrop.style.zIndex = 1050
  }
}

//2022/12/1 TrungNT Fix for UAT#5678: CT10 (Ph2-R20221222)
const hiddenDeleteModal = () => {
  modalDelete.value.hide()
}

const deleteTargetPostId = ref<string>()
const deleteTargetPostCommentId = ref<string>()
const deleteTargetCommentPublished = ref<boolean>()

const setCommentData = (post_id, id, published) => {
  deleteTargetPostId.value = post_id
  deleteTargetPostCommentId.value = id
  deleteTargetCommentPublished.value = published
}

onMounted(() => {
  if (route.params?.id) {
    store.dispatch(USER_POST_STORE.ACTIONS.GET_OPERATIONAL_POST, {
      chatroom_id: route.params.id,
      params: { ...route.query, page_of_number: route.query?.page_of_number || 30 },
    })

    getListUser()
  }
  // Show modal detail if exists query post_id
  if (route.query?.post_id) {
    setCurrentDataPostDetail(route.query?.post_id.toString(), 'viewPost')
  }
})

const path = ref(route.path)
watch(
  () => route,
  (oldPath) => {
    if (route.params?.id && oldPath?.path === path.value) {
      store.dispatch(USER_POST_STORE.ACTIONS.GET_OPERATIONAL_POST, {
        chatroom_id: route.params.id,
        params: { ...route.query, page_of_number: route.query?.page_of_number || 30 },
      })
    }
  },
  {
    // immediate: true,
    deep: true,
  }
)

const showCommentUserDetailInformation = async (comment: CommentType) => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id: route.params.id, userID: comment.management_no, userType: comment.user_type, isAdmin: true })
  changeModalElevation(ARTICLE_MODAL_ID, 'backdrop')
  if (comment.user_type === 'alumni') {
    commentAlumniInfoModal.value?.show()
  } else {
    commentUserInfoModal.value?.show()
  }
}

const updateCommentPublishedState = async (comment: CommentType) => {
  const requestPayload = {
    post_id: comment.post_id ?? 0,
    comment_id: comment.id ?? 0,
    published: !comment.published,
  }
  await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.UPDATE_COMMENT, requestPayload)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('adminUserPost')), 1),
      _createVNode(Search, { userPost: false }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ModalCreate, { hasThreeTabs: true })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(TotalRecords, {
        totalRecords: _unref(postData)?.total_records
      }, null, 8, ["totalRecords"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Pagination, {
          totalDataOfPage: _unref(postData)?.posts?.length,
          totalPage: _unref(postData).total_pages
        }, null, 8, ["totalDataOfPage", "totalPage"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(Table, {
          columns: [
          { field: 'postTitleSearch', name: _unref(translate)('title') },
          { field: 'post_content_type', name: _unref(translate)('postType'), sort: _ctx.sortField === 'post_content_type' },
          { field: 'total_likes', name: _unref(translate)('like'), sort: _ctx.sortField === 'total_likes' },
          { field: 'total_comments', name: _unref(translate)('comment'), sort: _ctx.sortField === 'total_comments' },
          { field: 'total_interests', name: _unref(translate)('interest'), sort: _ctx.sortField === 'total_interests' },
          { field: 'management_no', name: _unref(translate)('managementNo'), sort: _ctx.sortField === 'management_no' },
          { field: 'customer_name', name: _unref(translate)('creator'), sort: _ctx.sortField === 'customer_name' },
          { field: 'created_at', name: _unref(translate)('dateSubmission'), sort: _ctx.sortField === 'created_at' },
          { field: 'edit', name: _unref(translate)('edit') },
          { field: 'delete', name: _unref(translate)('delete') },
        ],
          sortCells: ['post_content_type', 'total_likes', 'total_comments', 'total_interests', 'management_no', 'customer_name', 'created_at']
        }, {
          default: _withCtx(() => [
            (_unref(checkSearchData))
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(translate)('CT10searchNoData')), 1)
                ]))
              : (_unref(postData)?.posts?.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(translate)('CT10searchNoData')), 1)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(postData).posts, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: _normalizeClass(["align-middle text-center", { rowEven: index % 2 === 0, rowExaminated: !item.published }]),
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("u", {
                          class: "cursor-pointer",
                          onClick: ($event: any) => (setCurrentData(item.id, 'viewPost'))
                        }, _toDisplayString(item.title), 9, _hoisted_13)
                      ]),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(convertContentType(item.content_type)), 1),
                      (item.like_count === 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(item.like_count), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_16, [
                            _createElementVNode("u", {
                              class: "cursor-pointer",
                              "data-bs-Toggle": "modal",
                              "data-bs-target": "#like",
                              onClick: ($event: any) => (getLike(item.id))
                            }, _toDisplayString(_unref(numberWithCommas)(item.like_count)), 9, _hoisted_17)
                          ])),
                      (item.comment_count === 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(item.comment_count), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_19, [
                            _createElementVNode("u", {
                              class: "cursor-pointer",
                              onClick: ($event: any) => (setCurrentData(item.id, 'viewPost'))
                            }, _toDisplayString(_unref(numberWithCommas)(item.comment_count)), 9, _hoisted_20)
                          ])),
                      ([1, 5].includes(item.content_type))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString('-')))
                        : (item.content_type !== 1 && item.interest_count === 0)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(item.interest_count), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_23, [
                              _createElementVNode("u", {
                                class: "cursor-pointer",
                                "data-bs-Toggle": "modal",
                                "data-bs-target": "#interest",
                                onClick: ($event: any) => (getInterest(item.id))
                              }, _toDisplayString(_unref(numberWithCommas)(item.interest_count)), 9, _hoisted_24)
                            ])),
                      _createElementVNode("td", null, _toDisplayString(item.management_no), 1),
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(UserAliasIcon, {
                            userType: item?.user_type
                          }, null, 8, ["userType"]),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(ReplayName)(item?.is_deleted_in_30_days, item?.available, item?.family_name, item?.given_name, item?.user_type)) + " " + _toDisplayString(item?.user_type == 2 && [0, 1].includes(item?.is_deleted_in_30_days) ? `（ ${item?.display_name} ）` : ''), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(item.created_at ? _unref(dayjs)(item.created_at).format('YYYY/MM/DD HH:mm:ss') : ''), 1)
                      ]),
                      _createElementVNode("td", {
                        class: _normalizeClass(['cursor-pointer w_100']),
                        onClick: ($event: any) => (item.content_type !== 5 && setCurrentData(item.id, 'viewEdit'))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-pen", item.content_type === 5 ? 'opacity-25' : 'color-edit'])
                        }, null, 2)
                      ], 8, _hoisted_30),
                      _createElementVNode("td", {
                        class: "cursor-pointer w_100",
                        onClick: ($event: any) => (setCurrentData(item.id, 'viewDelete'))
                      }, _hoisted_33, 8, _hoisted_31)
                    ], 2))
                  }), 128))
          ]),
          _: 1
        }, 8, ["columns"])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(Pagination, {
          totalDataOfPage: _unref(postData)?.posts?.length,
          totalPage: _unref(postData).total_pages
        }, null, 8, ["totalDataOfPage", "totalPage"]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ])
    ]),
    _createVNode(Loading, {
      loading: _unref(postData).loading
    }, null, 8, ["loading"]),
    _createVNode(ModalDelete, {
      post: currentData.value?.viewDelete,
      onHiddenDeleteModal: hiddenDeleteModal,
      contentType: postItem.value?.content_type
    }, null, 8, ["post", "contentType"]),
    _createVNode(ModalEdit, {
      post: currentData.value?.viewEdit,
      hasThreeTabs: true,
      userPost: false,
      count: count.value,
      modalEdit: modalEdit.value
    }, null, 8, ["post", "count", "modalEdit"]),
    _createVNode(ModalEditSuccess),
    _createVNode(ModalCreateSuccess),
    _createVNode(InterestModal),
    _createVNode(LikeModal),
    _createVNode(PostModal, {
      onSetCommentData: setCommentData,
      onShowDeleteCommentModal: showDeleteCommentModal,
      onShowUpdateCommentErrorModal: showUpdateCommentErrorModal,
      onShowUpdateStatusCommentModal: showUpdateStatusCommentModal,
      postId: currentData.value?.viewPost?.id,
      postDetail: currentData.value?.viewPost,
      userPost: false,
      "list-user": _unref(listUser),
      listUserMention: _unref(listUserMention)
    }, null, 8, ["postId", "postDetail", "list-user", "listUserMention"]),
    _createVNode(CommunitySitePostModal, {
      ref: (_value, _refs) => {
        _refs['articleDetailModalController'] = _value
        articleDetailModalController.value = _value
      },
      modalId: _unref(ARTICLE_MODAL_ID),
      onShowDeleteCommentModal: showDeleteCommunitySiteCommentModal,
      onUpdateCommentPublishedState: updateCommentPublishedState,
      onShowCommentUserDetailInformation: showCommentUserDetailInformation
    }, null, 8, ["modalId"]),
    _createVNode(ModalUpdateStatusChat),
    _createVNode(ModalUpdatePrivateSuccess),
    _createVNode(ModalUpdatePublicSuccess),
    _createVNode(PortfolioAlumni),
    _createVNode(PortfolioUser),
    _createVNode(DeleteCommentModal, {
      onShowDeleteCommentSuccessModal: showDeleteCommentSuccessModal,
      postId: deleteTargetPostId.value,
      postCommentId: deleteTargetPostCommentId.value,
      create_by_admin: true,
      commentPublishedFlg: deleteTargetCommentPublished.value,
      handleDeleteClick: _ctx.onCommunitySiteCommentDeleteConfirmClick
    }, null, 8, ["postId", "postCommentId", "commentPublishedFlg", "handleDeleteClick"]),
    _createVNode(DeleteCommentSuccessModal, { "is-delete": commentIsDelete.value }, null, 8, ["is-delete"]),
    _createVNode(UpdateCommentErrorModal),
    _createVNode(ModalConfirmStatusComment, { onAfterUpdateComment: afterUpdateStatusComment }),
    _createVNode(ModalUpdateStatusCommentResult, {
      "result-success": _unref(resultUpdateStatusComment).success,
      "comment-published": _unref(resultUpdateStatusComment).commentPublished
    }, null, 8, ["result-success", "comment-published"])
  ], 64))
}
}

})